import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/p1.png";
import projImg2 from "../assets/img/p2.png";
import projImg3 from "../assets/img/p3.1.png";
import projImg4 from "../assets/img/p4.png";
import projImg5 from "../assets/img/p6.png";
import projImg8 from "../assets/img/p8.png";
import projImg7 from "../assets/img/p7.png";
import projImg9 from "../assets/img/p9.jpg";
import projImg10 from "../assets/img/p10.jpg";
import projImg11 from "../assets/img/p11.jpg";
import projImg12 from "../assets/img/p12.jpg";
import projImg13 from "../assets/img/p13.jpg";
import projImg14 from "../assets/img/p14.jpg";

import colorSharp2 from "../assets/img/color-sharp2.png";
// import 'animate.css';
import TrackVisibility from 'react-on-screen';



export const Projects = () => {

  const projects = [
    {
      title: "Mobile App",
      description: "ReactNative",
      imgUrl: projImg11,
    },
    {
      title: "Mobile App",
      description: "Flutter & Firebase",
      imgUrl: projImg10,
    },
    {
      title: "Mobile App",
      description: "ReactNative",
      imgUrl: projImg9,
    },

    {
      title: "CRYPTO price & CRUD",
      description: "React & SQL",
      imgUrl: projImg14,
    },
  
    {
      title: "Ecommerce Web",
      description: "React",
      imgUrl: projImg12,
    },
    
    {
      title: "Q&A ",
      description: "React",
      imgUrl: projImg13,
    },
    
  ];

  return (
    <section className="project" >
      <Container>
        <Row>
          <Col size={10}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                
                <p></p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                <h2 id="project" className="show1">Projects</h2>
                <p >These projects are on my GitHub</p>
                
                
          
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center " id="pills-tab">
                    {/* <Nav.Item>
                      <Nav.Link eventKey="first">ProJects</Nav.Link>
                    </Nav.Item> */}
                    {/* <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item> */}
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane> */}
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      {/* <img className="background-image-right" src={colorSharp2} ></img> */}
      
    </section>
  )
}